import React from "react";
import {
	Text,
	View,
	StyleSheet,
	Pressable,
	FlatList,
	Image,
} from "react-native";

import RightIcon from "../../assets/images/arrowIcons/right";
const news1 = require("../../assets/images/news1.png");
const news2 = require("../../assets/images/news2.png");
const destaque3 = require("../../assets/images/destaque3.png");
//const readMoreButton = require("../../assets/images/buttonLerMais.png");

const LatestNewsRail = () => {
	const staticNews = [
		{
			id: 0,
			title: "Top 10 passeios incríveis em meio a natureza",
			imageSrc: news1,
			estimatedTime: "8 MIN",
		},
		{
			id: 1,
			title: "5 mochilões imperdíveis pela Europa",
			imageSrc: news2,
			estimatedTime: "8 MIN",
		},
		{
			id: 2,
			title: "Wild MISSINGNO appeared!",
			imageSrc: destaque3,
			estimatedTime: "???",
		},
	];

	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<Text style={styles.headerTitle}>Últimas notícias</Text>
				<Pressable onPress={() => alert("oi")}>
					<Text style={styles.headerSeeMore}>Ver mais</Text>
				</Pressable>
			</View>
			<View>
				<FlatList
					horizontal
					data={staticNews}
					ListFooterComponent={() => <View></View>}
					renderItem={({ item, index }) => (
						<View style={[styles.item, { marginLeft: index === 0 ? 24 : 0 }]}>
							<Text
								style={styles.preTitle}
							>{`LEITURA DE ${item.estimatedTime}.`}</Text>
							<Text style={styles.title}>{item.title}</Text>
							<Image source={item.imageSrc} style={styles.image} />
							<Pressable style={styles.btn} onPress={() => alert("oi")}>
								<Text style={styles.readmore}>Ler mais</Text>
								<RightIcon />
							</Pressable>
						</View>
					)}
				/>
			</View>
		</View>
	);
};

export default LatestNewsRail;

const styles = StyleSheet.create({
	container: {
		marginBottom: 50,
	},
	header: {
		flexDirection: "row",
		marginBottom: 12,
		justifyContent: "space-between",
		paddingHorizontal: 24,
	},
	headerTitle: {
		fontFamily: "DmSans-bold",
		fontSize: 18,
		color: "#727683",
	},
	headerSeeMore: {
		fontFamily: "DmSans-bold",
		fontSize: 14,
		color: "#0843F5",
		marginTop: 3,
	},
	readmore: {
		fontFamily: "DmSans-bold",
		fontSize: 15,
		color: "#0843F5",
		marginRight: 9,
	},
	item: {
		width: 222,
		height: 293,
		borderRadius: 20,
		marginRight: 15,
		backgroundColor: "#333",
		overflow: "hidden",
	},
	preTitle: {
		fontSize: 12,
		fontFamily: "DmSans-bold",
		lineHeight: 16,
		position: "absolute",
		top: 26,
		left: "10%",
		paddingRight: 30,
		zIndex: 2,
		color: "#fff",
	},
	title: {
		fontSize: 22,
		fontFamily: "DmSans-bold",
		lineHeight: 29,
		position: "absolute",
		top: 132,
		left: "10%",
		paddingRight: 40,
		zIndex: 2,
		color: "#fff",
	},
	image: {
		flex: 1,
	},
	btn: {
		flexDirection: "row",
		borderRadius: 25,
		justifyContent: "center",
		alignItems: "center",
		width: 115,
		height: 37,
		position: "absolute",
		bottom: 23,
		left: "10%",
		zIndex: 2,
		backgroundColor: "#FFF",
	},
	btnLabel: {
		color: "#0843F5",
		fontSize: 15,
		lineHeight: 22,
		letterSpacing: 0.2,
		fontFamily: "DmSans-bold",
	},

	imageReadMore: {
		width: 115,
		height: 37,
		marginLeft: 16,
		borderRadius: 20,
	},
});
